module.exports = {versao:  913 ,
old:false,
parceria:true,
url:"https://s-api.untaxi.com.br/"};
